import { 
    CHOOSE_LOFT,
    CLOSE_DIALOG,
    NEXT_PAGE,
    PREVIOUS_PAGE,
    RESET_CURRENT_PAGE,
    SIGN_IN_SUBMIT
} from '../actions/types'

const INITIAL_STATE = {
    currentPage: 0,
    openDialog: false,
    loftType: '',
    name: ''
}

export default (state = INITIAL_STATE, action ) => {

    // console.log('-- welcome reducer --')
    // console.log(action.payload)

    switch( action.type ){

        case SIGN_IN_SUBMIT:
            return {
                ...state, name: action.payload.name
            }

        case CHOOSE_LOFT :
            return {
                ...state,  openDialog: action.payload
            }

        case CLOSE_DIALOG:
            return {
                ...state, openDialog: action.payload
            }
        case NEXT_PAGE:
            return {
                ...state, currentPage: state.currentPage + action.payload
            }
        case PREVIOUS_PAGE:
            return {
                ...state, currentPage: state.currentPage - action.payload
            }
        case RESET_CURRENT_PAGE:
            return {
                ...state, currentPage: action.payload
            }

        default:
            return state
    }

}